"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * ScrollAnchor Component with moving target logic.
 * This is only used in this component not in core.
 * @param {Object} props React props
 * @param {String} props.targetId Scroll Target
 * @param {String} props.anchorText Anchor Text
 * @returns {React.ReactElement} ScrollAnchor Component
 * @public
 */
function ScrollAnchor({
  targetId,
  anchorText
}) {
  const navHeight = 72;
  const anchorNavHeight = 60;
  // OffsetThreshold is the threshold for the scroll to be considered off x px from the target
  const OffsetThreshold = 50;

  // Enhanced version for testing - only used in this component not in core
  const scrollToAnchor = (currentTarget, offset = 50) => {
    if (typeof document !== 'undefined') {
      const target = currentTarget?.dataset?.target;
      const element = document.getElementById(target);
      if (element && typeof window !== 'undefined') {
        let reScrollCount = 0;
        let scrollTimeout;
        let resizeObserver;
        // eslint-disable-next-line prefer-const
        let cleanupTimeout;
        const MAX_RE_SCROLLS = 3;
        const cleanup = () => {
          clearTimeout(scrollTimeout);
          clearTimeout(cleanupTimeout);
          if (resizeObserver) {
            resizeObserver.disconnect();
            resizeObserver = null;
          }
        };

        // Initial scroll
        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - offset
        });
        const recheckAndScroll = () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            const newOffset = element.offsetTop - offset;
            const currentScroll = window.pageYOffset;

            // Only re-scroll if we're off by more than OffsetThresholdpx AND haven't exceeded max re-scrolls
            if (Math.abs(newOffset - currentScroll) > OffsetThreshold && reScrollCount < MAX_RE_SCROLLS) {
              reScrollCount++;
              window.scrollTo({
                behavior: 'smooth',
                top: newOffset
              });
            }
          }, 200);
        };
        resizeObserver = new ResizeObserver(recheckAndScroll);
        resizeObserver.observe(document.body);
        cleanupTimeout = setTimeout(cleanup, 2000);
      }
    }
    return null;
  };
  const handleClick = event => {
    event?.preventDefault();
    scrollToAnchor(event?.currentTarget, navHeight + anchorNavHeight);
  };
  return /*#__PURE__*/_react.default.createElement(_text.default.a, {
    as: "title",
    size: -1,
    href: `#${targetId}`,
    "data-target": targetId,
    onClick: e => handleClick(e),
    "aria-label": `Scroll to ${targetId}`
  }, anchorText);
}
var _default = exports.default = ScrollAnchor;
ScrollAnchor.propTypes = {
  targetId: _propTypes.default.string,
  active: _propTypes.default.string,
  anchorText: _propTypes.default.string
};